import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Pagination from "../../common/TablePagination";
import "../../Fundraiser/FundsDeposited/fundsDeposited.scss";
import { useDispatch, useSelector } from "react-redux";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
// import debounce from "lodash.debounce";

const FundsDepositedTable = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.adminReducer?.loading);
  const debit = useSelector((state) => state?.adminReducer?.transactions?.debit);

  const filtered = React.useMemo(() => {
    const q = (searchQuery || '').toLowerCase().trim();
    if (!q) return debit || [];
    return (debit || []).filter((row) => {
      const values = [
        row?._id,
        separateDateTimeAndConvertToLocale(row?.createdAt)?.localDate,
        row?.fundraiser?.user?.name,
        String(row?.fundraiserFunds)
      ];
      return values.some((v) => String(v || '').toLowerCase().includes(q));
    });
  }, [debit, searchQuery]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [count, setCount] = useState(0);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // getFundsData(searchQuery);
  };

  const columns = [
    {
      name: "ID",
    },
    {
      name: "Date",
    },
    {
      name: "Fundraiser",
    },
    {
      name: "Funds",
    },
  ];

  return (
    <div className="col-span-12">
      {/* Desktop Table */}
      <TableContainer className="w-[100%] hidden md:block">
        <Table
          sx={{ borderCollapse: "separate", borderSpacing: "0px 8px" }}
          aria-label="simple table"
        >
          <TableHead className="bg-[#00ADEF]">
            <TableRow
              className="h-[50px]"
              sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
            >
              {columns.map((column) => {
                return (
                  <TableCell className="!text-[#FFFFFF] !font-[500] !text-[14px]">
                    {column.name}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered && filtered?.length > 0 ? (
              filtered?.map((funds, index) => (
                <TableRow
                  key={index}
                  className="h-[50px]"
                  sx={{
                    boxShadow: "0px 4px 4px 0px #00000040",
                    backgroundColor:
                      (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                  }}
                >
                  <TableCell>{funds?._id}</TableCell>
                  <TableCell>
                    {
                      separateDateTimeAndConvertToLocale(funds?.createdAt)
                        ?.localDate
                    }
                  </TableCell>
                  <TableCell>{funds?.fundraiser?.user?.name}</TableCell>
                  <TableCell>${funds?.fundraiserFunds}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  className="text-[16px] font-poppins font-[400] text-gray-500"
                >
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Mobile Card View */}
      <div className="block md:hidden space-y-4 mt-4">
        {filtered && filtered?.length > 0 ? (
          filtered?.map((funds, index) => (
            <div
              key={index}
              className="bg-white rounded-[10px] p-4 border border-[#E0E0E0] shadow-sm flex flex-col gap-3"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1 min-w-0">
                  <p className="text-[11px] font-[400] text-[#8C8C8C] font-poppins">Transaction ID</p>
                  <h3 className="text-[14px] font-[600] text-[#303030] font-poppins truncate">
                    {funds?._id}
                  </h3>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 text-[13px] font-poppins text-[#303030]">
                <div className="flex flex-col">
                  <span className="text-[#8C8C8C] text-[11px]">Date</span>
                  <span className="truncate">
                    {separateDateTimeAndConvertToLocale(funds?.createdAt)?.localDate || "N/A"}
                  </span>
                </div>
                <div className="flex flex-col">
                  <span className="text-[#8C8C8C] text-[11px]">Fundraiser</span>
                  <span className="truncate">{funds?.fundraiser?.user?.name || "N/A"}</span>
                </div>
                <div className="flex flex-col col-span-2">
                  <span className="text-[#8C8C8C] text-[11px]">Funds</span>
                  <span className="truncate font-[600] text-[#00ADEF]">
                    ${funds?.fundraiserFunds || "0"}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="bg-white rounded-[10px] p-8 border border-[#E0E0E0] text-center">
            <p className="text-[16px] font-poppins font-[400] text-gray-500">
              No data found
            </p>
          </div>
        )}
      </div>

      <Pagination totalPages={totalPages} handlePageChange={handlePageChange} />
    </div>
  );
};

export default FundsDepositedTable;